import Product from './ProductDetailPage';

export default Product;
